module.exports = __webpack_public_path__ + "static/media/400340_01.d7ed11ec.png";